import useBreakPointBasedPropIndex from "./useBreakPointBasedPropIndex";

export default function useBreakPointBasedProp(prop) {
  const i = useBreakPointBasedPropIndex();
  return Array.isArray(prop) ? (i < prop.length ? prop[i] : prop[prop.length - 1]) : prop;
}
